import { MimeType } from '../models';

export interface DragDropData {
  data?: any;
}

export interface DndEvent extends DragEvent {
  _dndUsingHandle?: boolean;
}

export function setDragData(event: DragEvent, data: DragDropData) {
  try {
    event.dataTransfer.setData(MimeType.JSON, JSON.stringify(data));
  } catch (e) {
    console.error(e);
  }
}

export function getDropData(event: DragEvent): DragDropData {
  return JSON.parse(event.dataTransfer.getData(MimeType.JSON));
}

export function getDirectChildElement(parentElement: Element, childElement: Element): Element {
  let directChild: Node = childElement;

  while (directChild.parentNode !== parentElement) {
    if (!directChild.parentNode) {
      return null;
    }

    directChild = directChild.parentNode;
  }

  return directChild as Element;
}

export function shouldPositionPlaceholderBeforeElement(event: DragEvent, element: Element) {
  const bounds = element.getBoundingClientRect();

  return (event.clientY < bounds.top + bounds.height / 2);
}

export const setDragImage = (event: DragEvent, dragImage: Element) =>
  event.dataTransfer.setDragImage(dragImage, 0, 0);

export const indexOfElement = (container: Element, element: Element) =>
  element && Array.prototype.indexOf.call(container.children, element);
